module.exports = __webpack_public_path__ + "img/award-8.4a7898d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/awards/award-8.jpg
// module id = 616
// module chunks = 1